import { render, staticRenderFns } from "./ChartDetailsSidebar.vue?vue&type=template&id=4ed5e39a&scoped=true"
import script from "./ChartDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./ChartDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ChartDetailsSidebar.vue?vue&type=style&index=0&id=4ed5e39a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed5e39a",
  null
  
)

export default component.exports